import { KEY } from "./constants";

export const selectSearch = (state) => state[KEY];
export const selectSearchState = (state) => state[KEY].searchState;
